// globalConfig.js
export const PRODUZIONE = false;
//export const DOMINIO = PRODUZIONE ? 'https://prodapiv1.snow.app' : 'https://tst-snowapp-api-01-wa.azurewebsites.net';
export const DOMINIO = process.env.REACT_APP_DOMINIO;
export const API_LOGIN = `${DOMINIO}/api/skipasslombardia/ip/Login`;
export const API_INFO_TESSERA = `${DOMINIO}/api/skipasslombardia/ip/Infopass/`;
